import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/core/app.module';
import { environment } from 'environments/environment';

if (environment.production) {
  // enableProdMode();
}

const bootstrapPromise = platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });

// Logging bootstrap information
bootstrapPromise
  .then(success => console.log(`Bootstrap success`))
  .catch(err => console.error(err));
